import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useLanguage } from '../context/LanguageContext';
import './AuthPages.css';

export default function ForgotPasswordPage() {
  const [email, setEmail]     = useState('');
  const [sent, setSent]       = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const { t } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.includes('@')) { setError(t('forgot.validEmail')); return; }
    setLoading(true);
    const { error: err } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    setLoading(false);
    if (err) { setError(err.message); return; }
    setSent(true);
  };

  return (
    <div className="auth-page">
      <div className="auth-page__card">
        <Link to="/" className="auth-page__logo" aria-label="CosmoEstates home">
          <img src="/images/logo-transparent.png" alt="CosmoEstates" className="auth-page__logo-img" />
        </Link>

        {sent ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(16,185,129,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <h1 className="auth-page__title">{t('forgot.checkEmail')}</h1>
            <p className="auth-page__sub">{t('forgot.sentMsg').replace('{email}', email)}</p>
            <p style={{ fontSize: 12, color: '#9CA3AF', marginTop: 12 }}>
              {t('forgot.notReceived')}{' '}
              <button style={{ background: 'none', border: 'none', color: '#B8924A', cursor: 'pointer', fontSize: 12, padding: 0, fontWeight: 600 }} onClick={() => setSent(false)}>
                {t('forgot.tryAgain')}
              </button>.
            </p>
          </div>
        ) : (
          <>
            <h1 className="auth-page__title">{t('forgot.title')}</h1>
            <p className="auth-page__sub">{t('forgot.sub')}</p>
            {error && <div className="auth-page__error">{error}</div>}
            <form onSubmit={handleSubmit} className="auth-page__form">
              <div className="auth-field">
                <label>{t('forgot.emailAddress')}</label>
                <input
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={e => { setEmail(e.target.value); setError(''); }}
                />
              </div>
              <button type="submit" className="auth-page__submit" disabled={loading}>
                {loading ? <span className="auth-page__spinner" /> : t('forgot.sendLink')}
              </button>
            </form>
            <div className="auth-page__switch">
              {t('forgot.rememberIt')} <Link to="/login">{t('forgot.signIn')}</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
